import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import useTitle from "utils/custom-hooks/useTitle";
import theme from "theme/default";
import {
  borderRadius,
  fontWeight,
  fontSize,
  gradients,
  padding,
} from "theme/defaultStyle";
import GradientIcon from "theme/icons/GradientIcon";
import ReportsNavIcon from "theme/icons/ReportsNavIcon";

const Container = styled("div")({
  backgroundColor: theme.palette.background.default,
  borderBottomLeftRadius: borderRadius.xlarge,
  borderBottomRightRadius: borderRadius.xlarge,
  position: "relative",
  "& .header": {
    display: "flex",
    alignItems: "center",
  },
  "& .headerContainer": {
    display: "flex",
    alignItems: "center",
    height: "28px",
    margin: "40px 0px 20px 0px",
    justifyContent: "space-between",
  },
  "& .titleReports": {
    background: gradients.redGradient03,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: fontWeight.bold2,
    fontSize: fontSize.xlarge2,
    paddingLeft: padding.small1,
  },
});

type ReportsHomeProps = {
  saveFileRef: any;
  saveFileChangeRef: any;
  tabSaveChangesRef?: any;
};

const ReportsHome = ({
  saveFileRef,
  saveFileChangeRef,
  tabSaveChangesRef,
}: ReportsHomeProps) => {
  useTitle("Stewart Connect Policy Portal - Reports");

  return (
    <Container>
      <Box className="headerContainer">
        <Box className="header">
          <GradientIcon Icon={ReportsNavIcon} />
          <Typography
            className="titleReports"
            variant="h6"
          >
            Reports
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ReportsHome;
